import { render } from "./FaqDeleteModal.vue?vue&type=template&id=310d13f3&scoped=true&ts=true"
import script from "./FaqDeleteModal.vue?vue&type=script&lang=ts"
export * from "./FaqDeleteModal.vue?vue&type=script&lang=ts"

import "./FaqDeleteModal.vue?vue&type=style&index=0&id=310d13f3&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310d13f3"]])

export default __exports__